const colors = ['#f2f0f7', '#cbc9e2', '#9e9ac8', '#756bb1', '#54278f'];
const breaks = [0, 25, 50, 340, 2600];
export const get_choropleth_breaks = () => {
  //
  /*
  return [
    ...breaks.map((b, i) => {
      return [b, colors[i]];
    }),
  ];
  */
  return [
    [breaks[0], colors[0]],
    [breaks[1], colors[1]],
    [breaks[2], colors[2]],
    [breaks[3], colors[3]],
    [breaks[4], colors[4]],
  ];
};

export const get_legend = (title, renderer, { is_density = false }) => {
  const sub_title = is_density ? 'au km2 par IRIS' : '';
  return `
  <article class="slds-card">
    <div class="slds-card__body slds-card__body_inner">
      <div class="slds-text-title_caps slds-border_bottom slds-text-align_center slds-p-around_xx-small">${title}</div>
      <div class="legend-subtitle slds-text-align_center">${sub_title}</div>
      <div class="slds-p-around_xx-small">
        ${renderer.getLegendElement()}
      <div>      
    </div>    
  </article>`;
};
